import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import image from '../../Assets/heroSection/1image.jpg';
export interface SectionHero2Props {
  className?: string;
}

const SectionEventHero1: FC<SectionHero2Props> = ({ className = "" }) => {
 
  return (
<div className={`relative w-full min-h-[340px] h-auto overflow-hidden ${className}`}>
  <img src={image} className="w-full object-cover" alt="" />
</div>


  );
};

export default SectionEventHero1;
